import { PRODUCTS_URL, UPLOAD_URL } from "../constants/constants";
import { apiSlice } from "./apiSlice";

export const productsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProducts: builder.query({  //builder.queryがGET、builder.mutationがPUT,POST,DELETE
            query: ({ keyword, pageNumber, gender, area, parentCategory, categorySlug, tag, shopId }) => ({
                url: PRODUCTS_URL,
                params: {
                    keyword,
                    pageNumber,
                    gender,
                    area,
                    parentCategory,
                    categorySlug,
                    tag, // タグIDが配列として渡される場合、カンマ区切りの文字列に変換
                    shopId, // ショップIDが配列として渡される場合、カンマ区切りの文字列に変換
                },
            }),
            providesTags: ["Products"], //useGetProductsQueryの引数に渡すことでキャッシュを使うことができる
            keepUnusedDataFor: 60,
        }),
        getShopProductsByAdmin: builder.query({
            query: ({shopId, status, pageNumber}) => ({
                url: `${PRODUCTS_URL}/shop/${shopId}/admin`,
                params: { status, pageNumber },
            }),
            providesTags: ["Products"],
            keepUnusedDataFor: 5
        }),
        getProductDetails: builder.query({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}`,
            }),
            keepUnusedDataFor: 60
        }),
        createProductsByAdmin: builder.mutation({
            query: ({count, shopId}) => ({
                url: `${PRODUCTS_URL}/shop/${shopId}/admin`,
                method: "POST",
                body: { count },
            }),
            invalidatesTags: ["Products"],
        }),
        updateProductByAdmin: builder.mutation({
            query: (data) => ({
                url: `${PRODUCTS_URL}/${data.productId}/admin`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Products"], //Productsタグがついているデータをキャッシュから削除する
        }),
        uploadProductImageByAdmin: builder.mutation({
            query: ({ productId, formData }) => ({
                url: `${UPLOAD_URL}/product/${productId}/admin`,
                method: "POST",
                body: formData,
            }),
        }),
        uploadSubImagesByAdmin: builder.mutation({
            query: ({ productId, formData }) => ({
                url: `${UPLOAD_URL}/product/${productId}/subimages/admin`,
                method: "POST",
                body: formData,
            }),
            invalidatesTags: ["Products"],
        }),
        deleteProductImageByAdmin: builder.mutation({
            query: (previousImage) => ({
                url: `${UPLOAD_URL}/delete/admin`,
                method: "DELETE",
                body: previousImage,
            }),
        }),
        deleteProductByAdmin: builder.mutation({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}/admin`,
                method: "DELETE",
            }),
            invalidatesTags: ["Products"],
        }),
        getTopProducts: builder.query({
            query: () => ({
                url: `${PRODUCTS_URL}/top`,
            }),
            // providesTags: ["Products"],
            keepUnusedDataFor: 5
        }),
        addTagsToProduct: builder.mutation({
            query: ({ productId, tagIds }) => ({ 
                url: `${PRODUCTS_URL}/${productId}/addtags`,
                method: "PUT",
                body: { tagIds },
            }),
            invalidatesTags: ["Products", "Tags"],
        }),
        removeTagsFromProduct: builder.mutation({
            query: ({ productId, tagIds }) => ({
                url: `${PRODUCTS_URL}/${productId}/removetags`,
                method: "PUT",
                body: { tagIds },
            }),
            invalidatesTags: ["Products", "Tags"],
        }),
        checkoutProductAtShop: builder.mutation({
            query: ({productId}) => ({
                url: `${PRODUCTS_URL}/${productId}/checkout`,
                method: "PUT",
            }),
            invalidatesTags: ["Products"],
        }),
        cancelCheckoutProductsAtShop: builder.mutation({
            query: ({ productIds }) => ({
                url: `${PRODUCTS_URL}/myshop/cancel-checkout`,
                method: "PUT",
                body: { productIds },
            }),
            invalidatesTags: ["Products"],
        }),
    }),
});

export const { 
    useGetProductsQuery, 
    useGetShopProductsByAdminQuery,
    useGetProductDetailsQuery, 
    useCreateProductsByAdminMutation,
    useUpdateProductByAdminMutation,
    useUploadProductImageByAdminMutation,
    useUploadSubImagesByAdminMutation,
    useDeleteProductImageByAdminMutation,
    useDeleteProductByAdminMutation,
    useGetTopProductsQuery,
    useAddTagsToProductMutation,
    useRemoveTagsFromProductMutation,
    useCheckoutProductAtShopMutation,
    useCancelCheckoutProductsAtShopMutation,
} = productsApiSlice;